import { Box, Grid, TextField, Typography, ToggleButton, ToggleButtonGroup, Stack } from '@mui/material';
import type { SignupData } from './SignUpWizard';

const darkInputSx = {
  '& .MuiOutlinedInput-root': {
    color: '#f0f0f5',
    '& fieldset': { borderColor: 'rgba(255,255,255,0.15)' },
    '&:hover fieldset': { borderColor: 'rgba(255,255,255,0.3)' },
    '&.Mui-focused fieldset': { borderColor: '#3d7aff' },
  },
  '& .MuiInputLabel-root': { color: '#6b7280' },
  '& .MuiInputLabel-root.Mui-focused': { color: '#3d7aff' },
  '& .MuiInputBase-input::placeholder': { color: '#6b7280', opacity: 1 },
};

interface Props {
  data: SignupData;
  onChange: (partial: Partial<SignupData>) => void;
}

export function CompanyInfoStep({ data, onChange }: Props) {
  return (
    <Stack spacing={3}>
      <Typography variant="h6" sx={{ fontWeight: 600, color: '#f0f0f5' }}>
        Company Information
      </Typography>

      <TextField
        label="Company Name *"
        value={data.companyName}
        onChange={(e) => onChange({ companyName: e.target.value })}
        fullWidth
        placeholder="e.g., Acme Pty Ltd"
        sx={darkInputSx}
      />

      <TextField
        label="Registered Name (optional)"
        value={data.registeredName}
        onChange={(e) => onChange({ registeredName: e.target.value })}
        fullWidth
        placeholder="e.g., Acme Proprietary Limited"
        sx={darkInputSx}
      />

      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            label="Registration Number (optional)"
            value={data.registrationNumber}
            onChange={(e) => onChange({ registrationNumber: e.target.value })}
            fullWidth
            placeholder="e.g., 2024/123456/07"
            sx={darkInputSx}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            label="Contact Phone *"
            value={data.contactPhone}
            onChange={(e) => onChange({ contactPhone: e.target.value })}
            fullWidth
            placeholder="e.g., +27112345678"
            sx={darkInputSx}
          />
        </Grid>
      </Grid>

      <Box>
        <Typography sx={{ color: '#a0a5b5', mb: 1, fontSize: 14 }}>Entity Type *</Typography>
        <ToggleButtonGroup
          value={data.entityType}
          exclusive
          onChange={(_, value) => value && onChange({ entityType: value })}
          fullWidth
        >
          <ToggleButton value="Organisation" sx={{ textTransform: 'none', color: '#a0a5b5', borderColor: 'rgba(255,255,255,0.15)', '&.Mui-selected': { backgroundColor: 'rgba(61,122,255,0.15)', color: '#3d7aff', borderColor: '#3d7aff' } }}>
            Organisation
          </ToggleButton>
          <ToggleButton value="Individual" sx={{ textTransform: 'none', color: '#a0a5b5', borderColor: 'rgba(255,255,255,0.15)', '&.Mui-selected': { backgroundColor: 'rgba(61,122,255,0.15)', color: '#3d7aff', borderColor: '#3d7aff' } }}>
            Individual
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </Stack>
  );
}
